// @flow
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  CurrencyInput,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../../messages';

type Props = {
  fieldName: string,
  disable: boolean,
  label?: string,
  providerName?: ?string,
};

const RenderCost = ({ fieldName, disable, label, providerName }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const fieldError = errors?.[fieldName];

  const providerCaption = providerName && !fieldError && (
    <FormattedMessage
      {...messages.poweredByProvider}
      values={{ provider: providerName }}
    />
  );

  return (
    <Box flex={1} data-test="render-cost">
      {label && (
        <Box
          component="label"
          sx={{ display: 'block', typography: 'labelLarge' }}
        >
          {label}
        </Box>
      )}
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <CurrencyInput
            {...field}
            disabled={disable}
            placeholder="0.00"
            min={0}
            max={9999.99}
            error={Boolean(fieldError)}
            // ' ' reserves the helper-text line's height so tiers stay aligned with no error or caption.
            helperText={fieldError?.message || providerCaption || ' '}
            FormHelperTextProps={
              providerCaption
                ? { 'data-test': 'offer-rent-provider' }
                : undefined
            }
            fullWidth
          />
        )}
      />
    </Box>
  );
};

export default RenderCost;
